export enum LobbyFilterStake {
    Any = -1, // local only
    Micro = 1,
    Low = 2,
    Med = 3,
    High = 4,
}
